// src/components/CharacterButton/CharacterButtonStyles.js

import {styled,css} from '@xstyled/styled-components';
import { MOBILE_BREAKPOINT } from '../../common/Constants';

export const CharacterButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fefdf5;
  color: black;
  border: 1px solid #e3c517;
  position: relative;
  font-size: clamp(6px, 2vw, 13px);
  padding-top: clamp(1px, 1vw, 5px);
  padding-bottom: clamp(1px, 1vw, 5px);
  padding-left: clamp(1px, 1vw, 15px);
  padding-right: 0;
  margin-bottom: clamp(1px, 1vw, 5px);
  border-radius: clamp(0px, 1vw, 4px);
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e3e2c1;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 70px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
`;

export const HoverMenuActivator = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  cursor: pointer;
  margin-right: 5px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 1px 3px 0 0;
    width: 80%;
    padding: 0px 1px;
    z-index: 1;
  }
`;

export const MobileButtonSpacing = styled.div` 
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
`;

export const HoverMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: rgba(247, 238, 186, 1);
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 999;
  width: 60px;
  align-items: center;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
  margin-top: -30px;
  transition: opacity 0.8s ease, transform 0.8s ease;

  ${({ $isActive }) =>
    $isActive &&
    css`
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    `}
`;

export const HoverMenuButton = styled.button`
  background: none;
  border: none;
  padding: clamp(1px, 1vw, 5px) clamp(1px, 1vw, 10px);
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  cursor: pointer;
  color: black;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }
`;
